import { jsx as _jsx } from "react/jsx-runtime";
import { Loading } from "@bluframe/blublocks";
import { NewsOutletItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = ({ loading, ...props }) => loading || !props.item ? (_jsx(Loading, {})) : (_jsx(NewsOutletItem, { ...props, item: props.item }));
export default Item;
